export default __webpack_public_path__ + "static/media/jQuery.66108f53.png";